<template>
  <div style="margin-top: 86px;">
    <div class="news-detail-content" v-html="newsContent">
    </div>
  </div>
</template>

<script>
  export default {

    name: 'NewsDetail',
    data() {
      return {
        newsId: '',
        newsContent: ''
      }
    },
    methods: {
    },
    created() {
      this.newsId = this.$route.params.newsId;
      let url = '/news/detail?newsId=' + this.newsId;
      this.getRequest(url).then(resp => {
        if (resp) {
          this.newsContent = resp.obj.newsContent;
        }
      });
    },
    /*监测路由的变化 */
    watch: {
      $route(to, from) {
        this.newsId = this.$route.params.newsId;
        let url = '/news/detail?newsId=' + this.newsId;
        this.getRequest(url).then(resp => {
          if (resp) {
            this.newsContent = resp.obj.newsContent;
          }
        });
      }
    }
  }
</script>

<style src="../../assets/css/newsDetail.css" scoped>

</style>
